import { render, staticRenderFns } from "./ModalAlertBornAt.vue?vue&type=template&id=aec289fa&scoped=true&"
import script from "./ModalAlertBornAt.vue?vue&type=script&lang=js&"
export * from "./ModalAlertBornAt.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertBornAt.vue?vue&type=style&index=0&id=aec289fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec289fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VDivider})
